import {getTexts} from '@oc/utils'
import textsJson from './messages.json'

export const messages = getTexts(textsJson)
